import { render, staticRenderFns } from "./common-holiday.vue?vue&type=template&id=0a249204&scoped=true&"
import script from "./common-holiday.vue?vue&type=script&lang=js&"
export * from "./common-holiday.vue?vue&type=script&lang=js&"
import style0 from "./common-holiday.vue?vue&type=style&index=0&id=0a249204&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a249204",
  null
  
)

export default component.exports